import React from "react";
import { Icon } from "lucide-react";
import { ironingBoard } from "@lucide/lab";

/**
 * Ferro/asse da stiro (lab)
 * size, color e strokeWidth sono passati a <Icon/> per stile coerente al DS.
 */
export default function IronIcon({
  size = 30,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}) {
  return (
    <Icon
      iconNode={ironingBoard}
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
}